import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ITranslateChallengeBody } from './translate-challenge-body-schema';
import type { ITranslateChallengeResponse } from './translate-challenge-response';
import { translateChallengeResponseSchema } from './translate-challenge-response';

interface ITranslateChallengeParams {
  challengeId: number;
  body?: ITranslateChallengeBody;
  options?: IRequestOptions;
}

export async function translateChallengeApi({
  challengeId,
  body,
  options,
}: ITranslateChallengeParams): Promise<IValidatedResponse<ITranslateChallengeResponse>> {
  return postRequest<ITranslateChallengeResponse>({
    path: `/sys/challenges/${challengeId}/translate`,
    body: body ?? {},
    schema: translateChallengeResponseSchema,
    options,
  });
}
